import React, { useState, useEffect } from 'react'
import { PageHeader, Button, Table, Skeleton, Popconfirm, Modal } from 'antd'
import { useQuery } from '@apollo/react-hooks'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'

import ResultError from '@packages/ResultError'
import { OPERATORS_ICON } from '@constants/IconsConstants'
import { useColumnFilterProps } from '@utils/columnFilter'
import { getOperatorsQuery } from '@graphql/queries'
import { useUpdateOperator, useDeleteOperator } from '@graphql/mutations'

import EditableCell from '../../EditableCell'
import ManageOperatorForm from '../ManageOperatorForm'

const tableProps = {
  size: 'middle',
  pagination: false,
}
const newButtonProps = {
  type: 'primary',
  icon: <PlusOutlined />,
  key: 'newOperator',
}

function ManageOperatorTable() {
  const [operatorsData, setOperatorsData] = useState(false)
  const [formModalVisible, setFormModalVisible] = useState(false)
  const { error, data } = useQuery(getOperatorsQuery)
  const [updateOperator] = useUpdateOperator()
  const [deleteOperator] = useDeleteOperator()
  const useFilterField = field => useColumnFilterProps(field)
  const toggleFormModal = () => setFormModalVisible(!formModalVisible)

  useEffect(() => {
    if (data) setOperatorsData(data.operators)
  }, [data])

  const handleSave = data => {
    const { id, name } = data
    const newData = [...operatorsData]
    const index = newData.findIndex(item => item.id === data.id)
    const item = newData[index]

    newData.splice(index, 1, { ...item, ...data })

    if (JSON.stringify(newData) !== JSON.stringify(operatorsData)) {
      updateOperator({
        variables: {
          id,
          data: {
            name: { set: name },
          },
        },
      })

      setOperatorsData(newData)
    }
  }

  const handleDelete = id => {
    deleteOperator({
      variables: { id },
      refetchQueries: ['GetOperatorsQuery'],
    })
  }
  const columns = [
    {
      dataIndex: 'name',
      title: 'Nome',
      editable: true,
      ...useFilterField('name'),
    },
    {
      align: 'center',
      render: (value, { id, name }) => (
        <Popconfirm
          title={`Tem a certeza que quer eliminar ${name} ?`}
          onConfirm={() => handleDelete(id)}
          okText="Sim"
          cancelText="Não"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ]
  const mappedColumns = columns.map(col => {
    if (!col.editable) return col

    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    }
  })

  return (
    <>
      <Modal
        title="Novo operador"
        visible={formModalVisible}
        onCancel={() => toggleFormModal()}
        footer={null}
      >
        <ManageOperatorForm afterSubmit={() => toggleFormModal()} />
      </Modal>

      <PageHeader
        title="Operadores"
        avatar={{ src: OPERATORS_ICON }}
        extra={[
          <Button {...newButtonProps} onClick={() => toggleFormModal()}>
            Novo operador
          </Button>,
        ]}
      />

      {error && <ResultError />}

      <Skeleton loading={!error && !operatorsData} active>
        {operatorsData && (
          <Table
            components={EditableCell.Components}
            columns={mappedColumns}
            dataSource={operatorsData}
            rowKey={({ id }) => id}
            rowClassName={() => 'editable-row'}
            {...tableProps}
          />
        )}
      </Skeleton>
    </>
  )
}

export default ManageOperatorTable
